const InitialState = { value: [], loading: true }

export const reducer = (state = InitialState, message) => {
    if (!message) {
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }

    const { type, layer, events } = message || {}

    switch (message.type) {
        case 'start':
            return { value: { ...state } }

        case 'event': {
            return { ...state, value: events }
        }
        case 'endHistory':
            return {
                ...state,
                endHistory: true,
                loading: false
            }
        default:
            return {
                ...state
            }
    }
}
